<template>
    <v-container class="mt-5 mx-auto">
        <v-row no-gutters dense>
            <v-card
            class="pa-2 "
            outlined
            tile
            dark
            width="180"
            >
                Name
            </v-card>
            <v-card
            class="pa-2"
            outlined
            tile
            dark
            width="180">
                {{ userName }}
            </v-card>
        </v-row>
        <v-row no-gutters>
            <v-card
            class="pa-2"
            outlined
            tile
            dark
            width="180">
                Phone
            </v-card>
            <v-card
            class="pa-2"
            outlined
            tile
            dark
            width="180">
                {{  }}
            </v-card>
        </v-row>
    </v-container>
</template>
    
<script>
export default {
    computed: {
        userName() {
            return this.$store.getters['auth/fullName']
        },
    },
}
</script>

<style scoped>

</style>